import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Icon } from '@codex/icons';
import { touchDeviceType } from './utils/filterHelpers';

import CheckboxList from './presentionalComponents/CheckboxList';
import FiltersMobileButtons from './presentionalComponents/FiltersMobileButtons';
import { changeRegularFilter } from '../../reduck/listingPagePages.reduck';
import { getActiveListingPage } from '../../reduck/selectors';
import ConnectedSegmentFilters from '../TopLevelContainers/ConnectedSegmentFilters';

import { OptionList } from './styled';

class Filter extends PureComponent {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (!nextProps.isTouchDeviceType) {
      return {
        checkboxesItems: {
          ...nextProps.filterItemData,
          values: nextProps.filterItemData.values.map((value) => ({ ...value }))
        }
      };
    }

    if (
      typeof prevState.previousFilterItemData === 'undefined' || // Condition for first render
      prevState.previousFilterItemData !== nextProps.filterItemData || // if filter items changes after loading data, checkboxes items has to set from filterItemData prop
      (!nextProps.isProductRequestFinishedSuccessfully &&
        prevState.previousIsProductRequestFinishedSuccessfully) // if error occurs during loading data, checkboxes items has to set from filterItemData prop
    ) {
      return {
        previousIsProductRequestFinishedSuccessfully:
          nextProps.isProductRequestFinishedSuccessfully,
        previousFilterItemData: nextProps.filterItemData,
        checkboxesItems: {
          ...nextProps.filterItemData,
          values: nextProps.filterItemData.values.map((value) => ({ ...value }))
        }
      };
    }

    return {
      previousIsProductRequestFinishedSuccessfully: nextProps.isProductRequestFinishedSuccessfully
    };
  }

  constructor(props) {
    super(props);

    this.state = {};
  }

  onCheckboxOptionChange(filterId, checkboxData) {
    const {
      filterItemData,
      isTouchDeviceType,
      changeFilterValue,
      onlyOneFilterSelectedMode
    } = this.props;

    const newCheckboxesItemsAfterClick = {
      ...this.state.checkboxesItems,
      values: this.state.checkboxesItems.values.map((valueItem) =>
        (valueItem.value === checkboxData.value // eslint-disable-line no-nested-ternary
          ? { ...valueItem, selected: !valueItem.selected }
          : onlyOneFilterSelectedMode
            ? { ...valueItem, selected: false }
            : valueItem)
      )
    };

    if (!isTouchDeviceType) {
      changeFilterValue(filterItemData.id, newCheckboxesItemsAfterClick.values);

      // it's not neccessary to change state for checkboxes on desktop because request is triggered immediately
      return;
    }

    this.setState(() => ({
      checkboxesItems: newCheckboxesItemsAfterClick
    }));
  }

  renderCheckboxList() {
    const { filterItemData, isTouchDeviceType } = this.props;

    return (
      <OptionList className={'dc-filter__option-list'}>
        <CheckboxList
          id={filterItemData.id}
          checkboxSize={isTouchDeviceType ? 'small' : 'extra-small'}
          toggleCheckboxOption={({ filterId, checkboxData }) => {
            this.onCheckboxOptionChange(filterId, checkboxData);
          }}
          regularCheckboxesItems={this.state.checkboxesItems}
          renderCheckboxLabelsWithLinks={!isTouchDeviceType}
        />
      </OptionList>
    );
  }

  render() {
    const {
      filterItemData,
      isTouchDeviceType,
      loading,
      changeFilterValue,
      hideFilterItem,
      isProductRequestFinishedSuccessfully,
      noProductsOnPage,
      children
    } = this.props;

    return (
      <>
        {loading && !isTouchDeviceType && (
          /* Icon is just shown for desktop during loading */ <Icon
            icon={'Spinner'}
            style={{
              position: 'absolute',
              zIndex: 4,
              marginLeft: 'calc(50% - 20px)',
              width: '40px',
              height: '40px'
            }}
            spin
          />
        )}
        {filterItemData.id === 'segment_id' ? (
          <ConnectedSegmentFilters isMobile={isTouchDeviceType} />
        ) : (
          this.renderCheckboxList()
        )}
        {children ? children : null}
        {isTouchDeviceType && (
          <FiltersMobileButtons
            resetButtonDisabled={
              this.state.checkboxesItems.values.findIndex((valueItem) => valueItem.selected) === -1
            }
            resetButtonLabel={'Clear'} // TODO: add to translations
            applyButtonLabel={'Apply'} // TODO: add to translations
            onResetButtonClick={() => {
              this.setState(
                (prevState) => ({
                  checkboxesItems: {
                    ...prevState.checkboxesItems,
                    values: prevState.checkboxesItems.values.map((value) => ({
                      ...value,
                      selected: false
                    }))
                  }
                }),
                () => {
                  changeFilterValue(filterItemData.id, this.state.checkboxesItems.values);
                }
              );
            }}
            onApplyButtonClick={() => {
              hideFilterItem();
              changeFilterValue(filterItemData.id, this.state.checkboxesItems.values);
            }}
            showErrorMessage={!isProductRequestFinishedSuccessfully}
            showWarningMessage={noProductsOnPage}
          />
        )}
      </>
    );
  }
}

Filter.propTypes = {
  children: PropTypes.element,
  loading: PropTypes.bool,
  onlyOneFilterSelectedMode: PropTypes.bool,
  isProductRequestFinishedSuccessfully: PropTypes.bool.isRequired,
  noProductsOnPage: PropTypes.bool,
  filterItemData: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    values: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        selected: PropTypes.bool.isRequired,
        count: PropTypes.string
      })
    ).isRequired
  }).isRequired,
  isTouchDeviceType: PropTypes.bool.isRequired,
  hideFilterItem: PropTypes.func,
  changeFilterValue: PropTypes.func
};

Filter.defaultProps = {
  children: undefined,
  loading: false,
  onlyOneFilterSelectedMode: false,
  noProductsOnPage: false,
  hideFilterItem: () => {},
  changeFilterValue: () => {}
};

const mapStateToProps = (state) => ({
  isProductRequestFinishedSuccessfully: !state.listingPage.commonData.xhrStatus
    .productsRequestErrorMessage,
  isTouchDeviceType: state.listingPage.browser
    ? touchDeviceType(state.listingPage.browser.device.deviceType)
    : false,
  noProductsOnPage: getActiveListingPage(state).productList.length === 0
});

const mapDispatchToProps = (dispatch) => ({
  changeFilterValue: (filterId, values) => {
    dispatch(
      changeRegularFilter(
        filterId,
        values.filter((valueItem) => valueItem.selected).map((valueItem) => valueItem.value)
          .length > 0
          ? values.filter((valueItem) => valueItem.selected).map((valueItem) => valueItem.value)
          : undefined
      )
    );
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Filter);
